<template>
<v-menu v-model="menuAvatar" offset-x left :close-on-content-click="false">
  <template v-slot:activator="{ on }">
    <v-btn icon v-on="on" class="mx-0">
      <v-progress-circular indeterminate v-if="loading"></v-progress-circular>
      <v-avatar size="40" v-else>
        <v-img :src="userAvatar" v-if="userAvatar"></v-img>
        <v-icon size="40" v-else>mdi-account-circle</v-icon>
      </v-avatar>
    </v-btn>
  </template>
  <v-card width="240" class="pa-3">
    <template v-if="userId">
      <div class="mx-2 title black--text text-truncate">{{userName}}</div>
      <div class="mx-2 mb-4 subtitle-2 text-truncate">{{userMail}}</div>
    </template>
    <LanguageMenu class="mb-4"></LanguageMenu>
    <v-card-actions class="pa-0">
      <v-btn v-if="userId" outlined color="primary" @click="logout">{{ $t('logout') }}</v-btn>
      <v-btn v-else outlined color="primary" to="/login">{{ $t('login') }}</v-btn>
    </v-card-actions>
  </v-card>
</v-menu>
</template>

<script>
import User from '@/components/auth/User'
import LanguageMenu from '@/components/utils/LanguageMenu'

export default {
  name: 'UserAvatarMenu',
  mixins: [User],
  components: {
    LanguageMenu
  },
  data() {
    return {
      loading: false,
      menuAvatar: false
    }
  },
  methods: {
    logout() {
      this.$auth.signOut();
      window.location.href = '/';
    }
  },
  mounted() {
    this.loading = true;
    let unsubscribe = this.$auth.onAuthStateChanged(() => {
      this.loading = false;
      unsubscribe();
    });
  }
}
</script>
